import { useState } from "react";
import Icon from "../../Images/Cricket-Pages/Heading Icons/points-table.webp";
import TeamRanking from "./TeamRanking";
import PlayerRankingTable from "./PlayerRankingTable";
import AdBanner from "../AdBanner";
import { useBanners } from "../../Api/api";

const Ranking = ({ RankingFor }) => {
  const [type, setType] = useState("Batting");
  const [format, setFormat] = useState("ODI");

  const { horizontal, vertical} = useBanners();


  const rankingTypes = ["Batting", "Bowling", "All Rounder", "Team"];
  const formatTypes = ["ODI", "Test", "T20"];

  const tabClass = (active) =>
    `px-6 py-2 rounded-[32px] font-[600] cursor-pointer info-hover
     ${active ? "bg-[#DC9A2B] text-white" : "bg-white text-black"}`;

  return (
    <div className="mb-10 pt-4 pb-8 mx-4 xl:mx-0">
      <div className="xl:w-[60%] lg:w-[80%] w-full m-auto pb-2">
        <div className="bg-[#215DA5] rounded-lg py-3 mb-5">
          <p className="text-white md:text-[30px] text-[24px] font-semibold px-4 flex items-center justify-center lg:justify-start gap-4 mb-0">
            <img
              src={Icon}
              alt="ranking"
              className="w-[60px] p-2 bg-black border-2 border-white rounded-full"
            />
            ICC {RankingFor}&apos;s Cricket Ranking
          </p>
        </div>

        <div className="ranking-type lg:space-x-4 space-x-2 flex pb-3 border-b-2 border-[#dc9a2b12]">
          {rankingTypes.map((v) =>
            RankingFor === "Women" && v === "Team" ? null : (
              <span
                key={v}
                onClick={() => setType(v)}
                className={tabClass(v === type)}
              >
                {v}
              </span>
            )
          )}
        </div>
      </div>
 {/* ==========Advertisement============== */}
        <div className="lg:mb-5 mb-[10px]"><AdBanner data={horizontal} type="horizontal" /></div>
      <div className="my-4 xl:w-[60%] lg:w-[80%] w-full m-auto pb-4">
        <div className="flex space-x-2 lg:space-x-4 pb-4 border-b-2 border-[#dc9a2b12]">
          {formatTypes.map((v) =>
            RankingFor === "Women" && v === "Test" ? null : (
              <span
                key={v}
                onClick={() => setFormat(v)}
                className={tabClass(v === format)}
              >
                {v}
              </span>
            )
          )}
        </div>

        {RankingFor === "Men" && type === "Team" ? (
          <TeamRanking formatTypes={format} />
        ) : (
          <PlayerRankingTable
            RankingFor={RankingFor}
            rankingTypes={type}
            formatTypes={format}
          />
        )}

        {/* ==========Advertisement============== */}
        <div className="lg:mb-5 mb-[10px] w-[10%] absolute top-[35%]"><AdBanner data={vertical} type="vartical" /> </div>

        {/* ==========Advertisement============== */}
        <div className="lg:mb-5 mb-[10px] w-[10%] absolute top-[35%] right-0"><AdBanner data={vertical} type="vartical" /> </div>
      </div>
    </div>
  );
};

export default Ranking;
